import { Flex, Heading, Paragraph } from "@ir/ui";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import {
  PageContent,
  PageHeader,
} from "@src/presentation/components/Layout/common";
import { RolePermissionsTabs } from "./utils";
import "./utils/RolePermissions.scss";

export const RolePermissions = () => {
  return (
    <ErrorBoundary>
      <PageHeader>
        <Flex align="center" gap={1} justifyContent="space-between">
          <Flex direction="column">
            <Heading level={5} className="text-grey-700 font-bold m-0">
              Role Permissions
            </Heading>
            <Paragraph className="text-grey-500 font-regular m-0">
              Define feature access and granular permissions per role
            </Paragraph>
          </Flex>
        </Flex>
      </PageHeader>
      <PageContent className="px-4 py-2">
        <RolePermissionsTabs orientation="vertical" />
      </PageContent>
    </ErrorBoundary>
  );
};
